export class SafetyNearMiss {
    id!: string
    indexId!: number
    job?: string | null
    incidentDateTime?: Date | string | null
    partiesInvolved?: string | null
    description?: string | null
    interviewFacts?: string | null
    correctiveAction?: string | null
    employeeSignature?: string | null
    signedOn?: Date | string | null
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean
    imageUrls: string[] = []
    imageFileNames: string[] = []

    jobDisplay?: string | null

    static createNew(): SafetyNearMiss {
        const item = new SafetyNearMiss()
        item.id = crypto.randomUUID()
        return item
    }
}
